<script>
import { VDialog } from 'vuetify/lib';
export default VDialog;
</script>
